import MainBlock from "components/DesignSystem/LayoutBlocks/MainBlock";
import React from "react";
import BaseErrorBoundary from "./BaseErrorBoundary";

class RequestErrorBoundary extends BaseErrorBoundary {
    render() {
        if (this.state.hasError) {
            return (
                <MainBlock>
                    <div className="flex h-screen">
                        <div className="m-auto">
                            <div className="rounded bg-white p-6 text-gray-800 shadow">
                                <h1 className="text-2xl font-bold">
                                    CEO Failed to initialize
                                </h1>
                                <p className="mt-4">
                                    {this.state.errorMessage}
                                </p>
                                <div className="mt-4 flex items-center justify-center space-x-4">
                                    <a
                                        href="/"
                                        className="focus:outline-none relative inline-flex justify-center rounded-md border border-transparent bg-green-600 py-2 px-4 text-sm font-medium text-white  shadow-sm hover:bg-green-700 focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50"
                                    >
                                        Reload CEO
                                    </a>
                                    <a
                                        href="https://snworks.zendesk.com/hc/en-us/requests/new"
                                        target="_blank"
                                        rel="noopener, noreferrer"
                                    >
                                        Or,{" "}
                                        <span className="text-green-600 underline">
                                            contact support
                                        </span>
                                        .
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </MainBlock>
            );
        }

        return this.props.children;
    }
}

export default RequestErrorBoundary;
